// Traducciones a nivel de página - Español
export const pagesEs = {
  home: {
    title: 'Inicio',
    description: 'Descubre vehículos de calidad y atención personalizada.',
  },
  vehicles: {
    title: 'Vehículos',
    found: 'vehículos encontrados',
    searchPlaceholder: 'Buscar por marca, modelo o año...',
    noResults: 'No se encontraron vehículos',
    noResultsDescription: 'Intenta ajustar los filtros o criterios de búsqueda',
    orderBy: 'Ordenar por',
  },
  vehicleDetails: {
    loading: 'Cargando detalles del vehículo...',
    notFound: 'Vehículo no encontrado',
    backToVehicles: 'Volver a vehículos',
  },
  financing: {
    title: 'Financiamiento',
    subtitle: 'Opciones flexibles para ti',
    description:
      'Obtén los mejores planes de financiamiento con tasas competitivas y aprobación rápida.',
  },
  consignments: {
    title: 'Consignaciones',
    subtitle: 'Vende tu auto con nosotros',
    description:
      'Nos encargamos de todo el proceso de venta para obtener el mejor valor.',
  },
  buyDirect: {
    title: 'Compramos tu auto',
    subtitle: 'Compra rápida y segura',
    description:
      'Recibe una oferta inmediata y vende tu auto con confianza.',
  },
  weSearchForYou: {
    title: 'Buscamos por ti',
    subtitle: 'Cuéntanos qué necesitas',
    description:
      'Describe tu vehículo ideal y encontraremos las mejores opciones.',
  },
};

